import "whatwg-fetch";

(function () {

    if (typeof window.CustomEvent === "function") return false;

    function CustomEvent(event, params) {
        params = params || { bubbles: false, cancelable: false, detail: undefined };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }

    CustomEvent.prototype = window.Event.prototype;

    window.CustomEvent = CustomEvent;
})();

export default class Collection {
    constructor() {
        this.state = {
            id: null,
            products: [],
            photos: [],
            resources: [],
            showcase: [],
            photoUrls: []
        };

        this.dom = { el: document.querySelector(".collection-header") };

        this.saveURL = "/umbraco/api/collection/save";
        this.bus = document.createElement("div");
        this.bus.events = ["request", "success", "failed", "pending"];

        if (this.dom.el) {
            this.assign();
            this.events();
        }
    }

    assign() {
        this.dom.empty_collection = this.dom.el.querySelector(
            "#empty-collection"
        );
    }

    events() {
        if (this.dom.empty_collection) {
            this.dom.empty_collection.addEventListener("click", e => {
                e.preventDefault();
                // console.log("empty");
                this.empty();
            });
        }
    }

    _removeFromArray(array, value) {
        if (array.includes(value)) {
            const position = array.indexOf(value);
            array.splice(position, 1);
        }

        return array;
    }

    _validate(type) {
        if (!(this.state[type] instanceof Array)) {
            //  console.log(type + ' is not a valid collection type.');
            return false;
        }
        return true;
    }

    _post() {
        this.trigger("request");

        return fetch(this.saveURL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        }).then(res => {
            // Need failed fallbacks
            this.trigger("success");
            return res.json();
        });
    }

    _get() {}

    trigger(event_name) {
        if (this.bus.events.indexOf(event_name) > -1) {
            this.bus.dispatchEvent(new CustomEvent(event_name));
        }
    }

    load() {
        const savedState = JSON.parse(localStorage.getItem("nzpg_collection"));
        for (let key in savedState) {
            this.state[key] = savedState[key];
        }
        return this.state;
    }

    updateCount() {
        const countElement = [
            ...document.querySelectorAll(".js-collection-count")
        ];
        const sum =
            this.state.photos.length +
            this.state.resources.length +
            this.state.showcase.length +
            this.state.products.length +
            this.state.photoUrls.length;
        countElement.map(el => {
            el.innerHTML = sum;
        });
    }

    save() {
        this.updateCount();
        localStorage.setItem("nzpg_collection", JSON.stringify(this.state));

        return this._post();
    }

    clear() {
        this.constructor();
        localStorage.removeItem("nzpg_collection");

        return localStorage;
    }

    add(type, id) {
        if (this._validate(type)) {
            if (id instanceof Array) {
                id.forEach(idItem => {
                    this.add(type, idItem);
                });
            } else {
                if (!this.state[type].includes(id)) {
                    // avoid duplicates
                    this.state[type].push(id);
                }
            }

            return this.state;
        }

        return false;
    }

    remove(type, id) {
        if (this._validate(type)) {
            this.state[type] = this._removeFromArray(this.state[type], id);
            return this.state;
        }
        
        return false;
    }

    empty() {
        new this.constructor();
        this.save();
        localStorage.removeItem("nzpg_collection");

        return true;
    }
}
